// Game-related constants

import { getGameDisplayName } from '../i18n/helpers';

/** @deprecated Use getGameDisplayName() from i18n/helpers instead */
export const GAME_NAMES: Record<string, string> = new Proxy({} as Record<string, string>, {
  get(_target, prop: string) {
    return getGameDisplayName(prop);
  },
});

export const TIMER_UPDATE_INTERVAL = 100; // milliseconds
export const HINT_DELAY = 5000; // milliseconds

/** Clue-reveal games: 20s game → 3s between clues, 30s → 4s. Match BE clueRevealConfig. Use when question.clueIntervalMs not set (e.g. room-state). */
export function getClueIntervalMs(timeLimitMs: number): number {
  if (timeLimitMs <= 20_000) return 3_000;
  if (timeLimitMs >= 30_000) return 4_000;
  return Math.round(3_000 + ((timeLimitMs - 20_000) / 10_000) * 1_000);
}
export const FLIP_DELAY = 500; // milliseconds
export const FADE_OUT_DURATION = 400; // milliseconds
export const STANDINGS_UPDATE_DELAY = 100; // milliseconds
